import React from 'react';
import { Box, Link, Stack, Typography } from '@mui/material';
import { GenerateMHRAccessCodeButton } from './GenerateMHRAccessCodeButton.tsx';

export const MHRInstructionsSection: React.FC = () => (
  <Stack sx={{ borderColor: 'divider', borderWidth: 1, borderStyle: 'solid', p: 1, borderRadius: 1 }}>
    <Stack component="ol" sx={{ pl: 3, m: 0, gap: 1 }}>
      <Typography component="li" variant="body2">
        Sign in to your{' '}
        <Link href="https://my.gov.au/en/myaccount/dashboard" target="_blank" rel="noopener">
          myGov
        </Link>{' '}
        account
      </Typography>
      <Typography component="li" variant="body2">
        Select <b>My Health Record</b> from your list of <b>Linked services</b>
      </Typography>
      <Typography component="li" variant="body2">
        From your <b>My Health Record</b> welcome page, select the record you want to access.
      </Typography>
      <Typography component="li" variant="body2">
        Select <b>My Healthcare Organisations</b> from the drop-down list. You will see a list of healthcare provider
        organisations who have access to your record.
      </Typography>
      <Typography component="li" variant="body2">
        If <b>Candor</b> is on the list, input the access token you created. If you cannot remember the access token,
        select <b>Manage Access</b> and create a new access token.
      </Typography>
      <Typography component="li" variant="body2">
        If <b>Candor</b> is not on the list, In <b>All Other Healthcare Providers</b> select <b>Manage Access</b>.
      </Typography>

      <Stack position="relative">
        <Typography component="li" variant="body2">
          Generate a temporary access code by clicking the <b>Generate Access Code</b> button.
        </Typography>
        <Stack component="ul">
          <Typography component="li" variant="body2">
            You are free to create your own code that is 4-8 characters long. Ensure you enter the correct code when
            prompted.
          </Typography>
        </Stack>

        <Box sx={{ marginLeft: '-24px', py: 2 }}>
          <GenerateMHRAccessCodeButton />
        </Box>
      </Stack>
      <Typography component="li" variant="body2">
        On the <b>Limit healthcare organisation access to My Health Record</b> page, enter the your randomly generated
        access code.
      </Typography>
      <Typography component="li" variant="body2">
        Re-enter the code and select <b>Save</b>
      </Typography>
    </Stack>
  </Stack>
);
